"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ = require("..");

var _Box = _interopRequireDefault(require("../Box"));

var __jsx = _react["default"].createElement;

/**
 * Input Raw
 */
var inputResetStyles = {
  border: 0,
  bg: "transparent",
  ":invalid": {
    boxShadow: "none",
    outline: "none"
  },
  "::-webkit-outer-spin-button, ::-webkit-inner-spin-button, ::-webkit-search-decoration, ::-webkit-search-cancel-button, ::-webkit-search-results-button, ::-webkit-search-results-decoration": {
    WebkitAppearance: "none"
  },
  WebkitAppearance: "none",
  MozAppearance: "textfield"
};

function InputRaw_(props) {
  var sx = props.sx,
      inputRef = props.inputRef,
      _onChange = props.onChange,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "inputRef", "onChange"]);

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  return __jsx(_Box["default"], (0, _extends2["default"])({
    as: "input",
    sx: [inputResetStyles, css],
    onChange: function onChange(e) {
      if (_onChange) {
        _onChange(e.target.value, e);
      }
    }
  }, restProps, {
    ref: inputRef
  }));
}

var InputRaw = _react["default"].forwardRef(function (props, ref) {
  return __jsx(InputRaw_, (0, _extends2["default"])({
    inputRef: ref
  }, props));
});

var _default = InputRaw;
exports["default"] = _default;